








import Vue from "vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import { Data, Methods, Computed, Props } from "./types";
import { sendGaEvent } from "@/helpers/ga-helper";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "FloatingMenuFooter",
  components: {
    Heading
  },
  props: {
    title: {
      type: String,
      required: true
    },
    gaEventCategory: {
      type: String,
      required: true
    }
  },
  methods: {
    handleClick() {
      sendGaEvent(this);
      this.$emit("click");
    }
  }
});
